import produce from 'immer';
import create from 'zustand';

const useStore = create(set => ({
  panesExpanded: {
    basic: true,
    facts: false,
    performance: false,
    fandl: false,
    wires: false,
    qanda: false,
  },
  set: fn => set(produce(fn)),
}));

export default useStore;
